import React from 'react';
import Layout from 'components/Layout';

import { fetchCheckoutCollectionWithContentFlow } from 'reduxModules/checkoutCollection/saga';
import { fetchCheckoutCollectionWithContent } from 'reduxModules/checkoutCollection/action';
import { getCheckoutCollectionById } from 'reduxModules/checkoutCollection/selector';

import { PREPACK } from 'constants/checkoutCollectionTypes';

import Prepack from './Prepack';

async function action(context) {
  const { store, params } = context;

  await store
    .runSagas(
      fetchCheckoutCollectionWithContentFlow,
      fetchCheckoutCollectionWithContent(params.id),
    )
    .toPromise();

  const collectionInfo = getCheckoutCollectionById(params.id)(store.getState());

  if (!collectionInfo || collectionInfo.collectionType !== PREPACK)
    return undefined;

  return {
    title: collectionInfo.title,
    description: collectionInfo.description,
    chunks: ['prepack'],
    component: (
      <Layout>
        <Prepack id={params.id} {...collectionInfo} />
      </Layout>
    ),
  };
}

export default action;
